export enum StoreType {
  APPLE = 'apple',
  GOOGLE = 'google',
  WEB = 'landing',
}

export const storeLink = {
  apple: 'https://getquin.onelink.me/X3Ev',
  google: 'https://getquin.onelink.me/X3Ev',
  web: 'https://getquin.onelink.me/X3Ev',
};

export const storeIcon = {
  apple: 'https://getquin.onelink.me/X3Ev',
  google: 'https://getquin.onelink.me/X3Ev',
  web: 'https://getquin.onelink.me/X3Ev',
};
